import ReactECharts from 'echarts-for-react'
import { usePieData } from './util'

const PieChart = ({option}: {option: any[]}) => {
  const options = usePieData(option)

  return <ReactECharts option={options} />
}
export default PieChart